import React, { useState, useEffect } from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"
import Message from "../../components/Message"

import styles from "../../css/Page.module.css"

const StartOnboarding = props => {

  return (
    <div>
      <Header title="Vem avser ärendet?" />
      <div className={styles.inputContainer}>
        <Input
          name="orgnr"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
          loading={props.orgnrLoading}
        />
        <Input
          name="newUserName"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
          hide={!props.orgnrVerified}
        />
        <Input
          name="newUserEmail"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
          hide={!props.orgnrVerified}
        />
        <Input
          name="startDate"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
          hide={!props.orgnrVerified}
        />
      </div>
      <Message text={props.orgnrVerifiedError} error={true} hide={props.orgnrVerified} />
      {/*<NavigationButtons
        inputState={props.inputState}
        process={props.process}
  />*/}
    </div>
  )
}
  
export default StartOnboarding